import React from 'react';

import MainLayout from 'layouts/MainLayout';
import MyPageLayout from 'layouts/MyPageLayout';

const MyPage = () => {
  return (
    <MainLayout>
      <MyPageLayout />
    </MainLayout>
  );
};

export default MyPage;
